import { useLayoutEffect } from 'react';

import { dispatchTrackingEvent } from '@context/tracking/utils';
import { useUser } from '@queries/useUser';

import { useLoyaltyStateQuery } from '../ProductBaseInfo/LoyaltyProgramBanner/hooks/useLoyaltyStateQuery';

export const useTrackLoyaltyStatus = ({ skip }: { skip?: boolean } = {}) => {
  const { data } = useLoyaltyStateQuery();
  const { isLoggedIn } = useUser({ ssr: true });

  // track ASAP
  useLayoutEffect(() => {
    if (data?.getLoyaltyState?.state && !skip) {
      dispatchTrackingEvent({
        event: 'user',
        user: {
          club: data.getLoyaltyState.state,
        },
      });
    }
  }, [data, isLoggedIn, skip]);
};
